const config = {
  rowSelection: false,
  columns: [
    {
      title: '应收单号',
      dataIndex: 'billNo',
      width: 190,
      render: 'clueIdRender',
      ellipsis: true,
    },
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '收款类型',
      dataIndex: 'receiptTypeName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '应收金额',
      dataIndex: 'receivableAmount',
      width: 140,
    },
    // {
    //   title: '实收金额',
    //   dataIndex: 'receiveAmount',
    //   width: 140,
    // },
    {
      title: '已核销金额',
      dataIndex: 'verifiedAmount',
      width: 140,
    },
    {
      title: '未核销金额',
      dataIndex: 'unverifiedAmount',
      width: 140
    },
    {
      title: '核销状态',
      dataIndex: 'verifyStateName',
      width: 100
    },
    {
      title: '应收日期',
      dataIndex: 'receivableDate',
      itemType: 'dateTime',
      width: 160
    },
     {
      title: '签单日期',
      dataIndex: 'signDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '开工日期',
      dataIndex: 'actualStartDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '完工日期',
      dataIndex: 'actualEndDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '支付状态',
      dataIndex: 'payStateName',
      width: 100
    },
    {
      title: '合同类型',
      dataIndex: 'budgetVersionDesc',
      width: 140
    },
    {
      title: '合同号',
      dataIndex: 'contractNo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '合同金额',
      dataIndex: 'budgetContractAmount',
      width: 100
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
      ellipsis: true,
      // ellipsis: {
      //   showTitle: true,
      // },
    },
  ],
  search: [
    {
      name: 'contractNo',
      label: '合同号',
    },
    {
      name: 'orderNo',
      label: '订单号',
    },
    {
      name: 'customerPhone',
      label: '客户电话',
    },
    {
      name: 'customerName',
      label: '客户名称',
    },
    {
      name: 'billNo',
      label: '应收单号',
    },
    {
      name: 'notEqualVerifyState',
      label: '显示未生效应收单',
      labelProps: {
        width: '150px',
      },
      itemType: 'select',
      key: 'value',
      labelKey: 'lable',
      data: [
        {
          lable: '不显示',
          value: 'verifyStateNotEffective'
        },{
          lable: '显示',
          value: 'noVerifyStateNotEffective'
        }
      ],
    },
    {
      name: 'receiptType',
      label: '收款类型',
      itemType: 'select',
      data: 'receiptTypeList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'verifyStateList',
      label: '核销状态',
      itemType: 'select',
      data: 'verifyStateList',
      mode: 'multiple',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'payState',
      label: '支付状态',
      itemType: 'select',
      data: 'payStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'contractType',
      label: '合同类型',
      itemType: 'select',
      data: 'contractTypeList',
      labelKey: 'desc',
      key: 'code',
    },
    {
      name: 'receivableDate',
      label: '应收日期',
      itemType: 'autoDate',
      allowClear: 'true'
    }
  ],
  searchInitialValues: {
    'notEqualVerifyState': 'verifyStateNotEffective'
  },
  footer: [
    
  ],
  // batchActions: [
  //   {
  //     label: '合并收款',
  //     type: 'primary',
  //     auth: 'ReceivableListMergeReceipts',
  //     events: ['onClick:onMergeReceipts'],
  //   }
  // ]
}

export default config
